import { render, staticRenderFns } from "./PaycheckDraftPeriodFormDraftLineHeader.vue?vue&type=template&id=4b8c548a&scoped=true&"
import script from "./PaycheckDraftPeriodFormDraftLineHeader.vue?vue&type=script&lang=ts&"
export * from "./PaycheckDraftPeriodFormDraftLineHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PaycheckDraftPeriodFormDraftLineHeader.vue?vue&type=style&index=0&id=4b8c548a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c548a",
  null
  
)

export default component.exports